<script>
// import ThisWeeksTargetGoals from './ThisWeeksTargetGoals';
export default {
  props: [ 'mainTargetForThisWeek' ],
  // components: { ThisWeeksTargetGoals },
  computed: {
    reasons() {
      return this.$store.getters['reasons'];
    },
  },
  methods: {
    async editMyReasons() {
      await this.$cookies.set('lastViewedTab', 'reasons');
      this.$router.push('/account');
    },
    launchMindMovie() {
      this.$cookies.set('mindmovie_shuffle', true, '1h');
      this.$router.push('/mindmovie');
    },
  },
};
</script>

<template>

<!--  <ThisWeeksTargetGoals :mainTargetForThisWeek="mainTargetForThisWeek" />-->

  <!-- IF USER HAS REASONS TO REMEMBER -->
  <div v-if="reasons && reasons.length" id="reasons-display-container">
    <v-card
      v-for="reason in reasons"
      :key="reason.id"
      :id="reason.id"
      variant="outlined"
      class="my-5"
    >
      <v-card-title>
        <div class="one-reason text-body-1">{{ reason.reason }}</div>
      </v-card-title>
    </v-card>

    <div id="remember-2-remember-bottom-links" class="d-flex justify-space-between">
      <p @click="editMyReasons"
        class="text-body-2 text-red-lighten-2"
      ><i>Revise your Vision</i></p>
      <p @click="launchMindMovie"
         class="text-body-2 text-red-lighten-2"
      ><i>Launch MindMovie</i></p>
    </div>
  </div>


  <!-- IF USER HAS NO REASONS TO REMEMBER YET -->
  <div v-else class="text-body-2 mt-5">
    <p class="mb-3"><strong>You have yet to add descriptions of your dream life come true, of the person you want to be.</strong></p>
    <p class="font-weight-bold text-center"
      @click.prevent="editMyReasons"
    >Add some now</p>
  </div>

</template>

<style lang="scss" scoped>
#reasons-display-container {
  @media screen and (min-width: 768px) {
    padding: 0 12px;
  }

  .one-reason { white-space: pre-line; }

  #remember-2-remember-bottom-links {
    p:hover { cursor: pointer; }
  }
}
a {
  color: black;
  text-decoration: none;
}
</style>
